import { Drive } from '@app/models/documents/directory/drive.model';
import { SystemFolderNamesEnum } from '@app/modules/documents-v2/enums';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { DriveNameFolder } from '@app/types/translatables/drive-name-display.options';
import { Node } from '@models/documents/directory/node.model';

export class NameColumn extends Column {
    title = 'table.document-nodes-index.name';
    property = 'name';
    sortable = true;
    sortField = 'name';
    type: CellDisplay = CellDisplay.string;
    hasIcon = true;

    constructor(protected parentDrive: Drive | null) {
        super();
    }

    getIcon(node: Node): string | null {
        if (node.isFolder()) {
            if (node.source.isSystemFolder === true) {
                switch (node.name) {
                    case SystemFolderNamesEnum.assigned:
                        return 'folderSign';
                    case SystemFolderNamesEnum.upload:
                        return 'folderUpload';
                    case SystemFolderNamesEnum.tasks:
                    case SystemFolderNamesEnum.training:
                        return 'folderLock';
                }
            }

            if (this.parentDrive) {
                if (this.parentDrive.isPublic()) {
                    return 'folderShared';
                }
                return 'folderPrivate';
            }

            if (node.parent?.isDrive()) {
                return DriveNameFolder[node.parent.name] ?? null;
            }

            // TODO
            //  Folder icon is unknown
            //  Expensive HTTP call to? /directories/nodes/{node}/drive
        }

        if (node.isCompanyDocument()) {
            if (node.source.file?.isSupportedImageType) {
                return 'documentImage';
            }
            return 'documentFile';
        }

        if (node.isEmployeeDocument()) {
            if (node.source.source?.isSupportedImageType) {
                return 'documentImage';
            }
            return 'documentFile';
        }

        return null;
    }

    getIconStyle(): null | { [key: string]: string } {
        return {
            height: '20px',
            width: '20px',
            'padding-right': '0',
            'margin-right': '10px',
            'flex-shrink': '0',
        };
    }

    getRowStyling(): null | { [key: string]: string } {
        return {
            display: 'flex',
            'align-items': 'center',
        };
    }

    getDisplayPropertyValue(node: Node): string {
        // Compose the translation key if the node is a system folder
        if (node.isFolder() && node.source.isSystemFolder === true) {
            const folderNameKey = Object.entries(SystemFolderNamesEnum).find(
                ([key, value]) => value === node.name
            )?.[0];
            return folderNameKey ? 'document.systemFolders.' + folderNameKey : node.name;
        }

        return node.name;
    }
}
